import { useState, useEffect, } from "react";

type AlternatingImageProps = {
    frameUrls: string[];
    style?: React.CSSProperties;
};

export const AlternatingImage = ({ style, frameUrls }: AlternatingImageProps) => {
  const [currentFrame, setCurrentFrame] = useState<number>(0);

  useEffect(() => {
    const interval = setInterval(() => {
        setCurrentFrame((prev) => (prev + 1) % frameUrls.length);
    }, 300);

    return () => clearInterval(interval);
  }, [frameUrls.length]);

  return (
    <div style={{ position: 'relative', ...style }}>
        {
            frameUrls.map((frameUrl, index) => (
                <img
                    key={index}
                    src={frameUrl}
                    alt=""
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: currentFrame === index ? 'block' : 'none',
                    }}
                />
            ))
        }
    </div>
  );
};